import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  cleinte='';
  constructor() { 
    let t = JSON.parse(atob(localStorage.getItem(environment.zc)));
					this.cleinte = t.nom
  }

  ngOnInit(): void {
  }
  checkin(){
    window.location.href ='/reserva';
  }
  despertador(){
    window.location.href ='/despertador';
  }
  roomservices(){
    window.location.href ='/roomservices';
  }
  gastos(){
    window.location.href ='/gastos';
  }
  hotel(){
    window.location.href ='/hotel';
  }
  restaurantes(){
    window.location.href ='/restaurantes-bares';
  }
}
